import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GooglePlacesLocationComponent } from './google-places-location.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlacesService } from 'src/app/services/places/places.service';



@NgModule({
  declarations: [GooglePlacesLocationComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    TypeaheadModule.forRoot(),
    NgbModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [GooglePlacesLocationComponent]
})
export class GooglePlacesLocationModule { }
